<template>
    <div class="filling-goods-div">
        <div style="padding-top: 5px; font-size: 16px">布匹盘点</div>
        <span style="color: red" v-if="hostcs" @click="reload()">测试服</span>
        <div style="display: flex; justify-content: space-between; align-items: center;margin-top: 10px;">
            <div style="display: flex; align-items: center;justify-content: space-between;width: 65%;">
                <div style="font-size: 14px;">卷号: </div>
                <input id="reel-input" class="getreel-input" @keyup.enter="goGck()" ref="getIDInpot" v-model="reeldata"
                    v-on:blur="hideMessage('reeldata')" readonly autocomplete="off" />
            </div>
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
        </div>
        <div style="padding:10px 10px; height: 20%;" class="print-only" id="popupPrint" v-if="AllowP">
            <div>
                <div class="list-data">
                    <div class="list-data-div-a">货号: {{ goods_number }}</div>
                    <div class="list-data-div-a">卷号: {{ reel }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a">仓库: {{ ck }}</div>
                    <div class="list-data-div-a">门幅: {{ menfu }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a">现存量: {{ count }}</div>
                    <div class="list-data-div-a" style="display: flex;">
                        <div style="text-align: left; font-size: 0.48rem; margin-right: 10px;">货位: </div>
                        <input class="list-data-div-a" v-model="goods" @input="changeGoods()">
                    </div>
                </div>
                <div class="list-data">
                    <div style="text-align: left; font-size: 0.48rem; margin-right: 10px;">盘点数量:</div>
                    <input class="list-data-div-a" v-model="count_up" type="number" @input="changeNum()">
                </div>
                <!-- <div class="list-data">
                    <div class="list-data-div-a">盘点状态:</div>
                    :class="{'ok': i.sign === 1, 'no': i.sign === 0}"  i.sign === 1 ? 'OK' : 'NO'
                    <div :class="type === '已盘点' ? 'Already' : 'Nalready'" :readonly="type == '已盘点'">{{ type }}</div>
                </div> -->
                <div class="list-data">
                    <div class="list-data-div-a" style="width:100%">上次盘点人: {{ people }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a" style="width:100%">上次盘点时间: {{ lasttime }}</div>
                </div>
            </div>
        </div>
        <div :style="style">
            <div class="goods-info-two-f" v-for="(i, index) in data" :key="index">
                <div style="width: 100%; text-align: right">
                    <van-icon name="cross" @click="deleteData(index)" style="margin: 5px 5px 0 0" size="22px" />
                </div>
                <div class="info-order-h">
                    <div style="width: 60%; display: flex; align-items: center">
                        <div class="right-Pandian">货号: {{ i.goods_number }}</div>
                    </div>
                    <div style="width: 40%; display: flex">
                        <div class="right-Pandian">数量: {{ i.count }}</div>
                    </div>
                </div>
                <div class="info-order-h">
                    <div style="width: 60%; display: flex">
                        <div class="right-Pandian">卷号: {{ i.reel }}</div>
                    </div>
                    <div style="width: 40%; display: flex">
                        <div class="right-Pandian">货位: {{ i.goods }}</div>
                        <!-- <div class="data-order">{{ i.goods }}</div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button v-if="AllowP" type="info" class="bottom-button" @click="go_check()">确认盘点</van-button>
            <!-- <van-button v-if="AllowP" type="danger" class="bottom-button" @click="go_back()">撤销</van-button> -->
        </div>
    </div>
</template>
  
<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import axios from 'axios';
import { Dialog } from "vant";
import { Toast } from "vant";
import moment from 'moment';
export default {
    name: "FabricInventory",
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            supplier_xh: "",
            count: "",
            count_up: "",
            data: [],
            style: "",
            allcount: 0,
            reeldata: "",
            goods_number: "",
            goods: '',
            reelInfo: "",
            reelInfo_up: "",
            gck_number_data: "",
            username: "",
            type: "未盘点",
            AllowP: false,
            nowtime: '',
            lasttime: '',
            jieliu: false,
            menfu: '',
            ck: '',
            people: '',
            checkType: false,
            audio: new Audio(require("@/assets/ww.mp3")),
            audio2: new Audio(require("@/assets/file.mp3")),
        };
    },
    mounted() {
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.5 + "px;overflow:scroll";
        setTimeout(() => {
            this.focus();
        }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    methods: {
        goGck() {
            // 输入卷号 弹出现存量
            if (this.reeldata == '' || this.reeldata == null) { Toast('请不要输入空卷号！'); return }
            var gg = this.data.filter(item => item.reel === this.reeldata);
            if (gg.length != 0) { Toast('该布匹已盘点在下方列表中'); this.reeldata = ''; return }
            this.get(this.APIOBJ.ClothAdjustment, { reel: this.reeldata }).then(
                (res) => {
                    if (res.data.status == 1) {
                        // this.supplier_xh = 'supplier_xh';
                        // this.supplier_name = 'supplier';
                        if (res.data.data.pd_status != '已盘点') {
                            console.log(this.data)
                            var list = {};
                            this.count_up = '';
                            list.count = res.data.data.store
                            list.goods_number = res.data.data.number;
                            list.reel = this.reeldata;
                            list.goods = res.data.data.goods;
                            list.username = this.username;
                            list.warehouse = res.data.data.warehouse;
                            this.data[this.allcount] = list;

                            this.count = res.data.data.store;
                            this.goods_number = res.data.data.number;
                            this.menfu = res.data.data.menfu;
                            this.reel = this.reeldata;
                            this.ck = res.data.data.warehouse;
                            this.people = res.data.data.pd_people;
                            this.lasttime = res.data.data.pd_time;
                            this.goods = res.data.data.goods;
                            this.type = res.data.data.pd_status || '未盘点';
                            this.AllowP = true;
                            this.reeldata = '';
                            this.allcount++
                        } else {
                            Toast('该布匹已盘点')
                            this.reeldata = '';
                            this.focus();
                        }
                    } else if (res.data.status == 0) {
                        this.reeldata = '';
                        this.focus();
                        this.audio2.play();
                        Toast(res.data.msg);
                    } else {
                        this.reeldata = '';
                        this.focus();
                        this.audio.play();
                        Toast('失败');
                    }
                }
            );
        },
        go_check() {
            // this.post('http://localhost/api/business/doPandian', {data:this.data}).then(
            //     (res) => {
            //     }
            // )
            if (this.checkType) {
                return
            }
            this.checkType = true;
            var url = window.localStorage.getItem("pdaBASEURL")
            axios({
                method: 'post',
                url: url + '/business/doPandian',
                data: this.data,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(res => {
                    if (res.data.status == 1) {
                        this.data = [];
                        this.count = '';
                        this.goods_number = '';
                        this.menfu = '';
                        this.reel = '';
                        this.ck = '';
                        this.people = '';
                        this.lasttime = '';
                        this.goods = '';
                        this.AllowP = false;
                        this.reeldata = '';
                        this.allcount = 0;
                        this.focus();
                        Toast('更新盘点成功');
                        this.checkType = false;
                    } else {
                        Toast('更新失败');
                        this.checkType = false;
                    }
                })
                .catch(error => {
                    // 处理错误
                    console.error(error);
                    this.checkType = false;
                });
        },
        changeNum() {
            if (this.count_up != '') {
                this.data[this.allcount - 1].count = this.count_up;
            } else {
                this.data[this.allcount - 1].count = this.count;
            }
        },
        changeGoods() {
            this.data[this.allcount - 1].goods = this.goods;
        },
        go_back() {
            this.get(this.APIOBJ.backPandian, { reel: this.reel }).then(
                (res) => {
                    if (res.data.status == 1) {
                        this.type = '未盘点';
                        Toast('撤销盘点成功')
                        this.focus();
                    } else {
                        Toast('撤销失败')
                    }
                }
            )
        },
        go_pp() {
            this.nowtime = moment().format('YYYY-MM-DD HH:mm:ss');
            this.JsBarcodeConfigData.text = this.reeldata;
            this.JsBarcodeConfigData.bottomtext = this.reeldata;
            this.show_print = true;
            this.jieliu = false;
        },
        reload() {
            window.location.reload();
            // this.$refs.getGCKInpot.focus();
            // this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
            // setTimeout(() => {
            //   this.$refs.getGCKInpot.removeAttribute("readonly");
            // }, 200);
        },
        deleteData(index) {
            Dialog.confirm({
                message: "确定要撤销该布匹盘点吗？",
            }).then(() => {
                this.data.splice(index, 1);
                // if (index == 0) {
                //     this.count = '';
                //     this.goods_number = '';
                //     this.menfu = '';
                //     this.reel = '';
                //     this.ck = '';
                //     this.people = '';
                //     this.lasttime = '';
                //     this.goods = '';
                //     this.reeldata = '';
                // }
                this.allcount--
                setTimeout(() => {
                    Toast('撤销成功')
                }, 0);
            });
        },
        hideMessage(title) {
            if (title === "reeldata") {
                if (this.reeldata === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
            if (title === "gck_number_data") {
                if (this.gck_number_data === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
        },
        holdRay() {
            this.ray = "扫描中";
            if (this.reeldata === "") {
                this.focus();
            } else if (this.gck_number_data === "") {
                this.gck_input();
            }
        },
        focus() {
            this.$refs.getIDInpot.focus();
            this.$refs.getIDInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
};
</script>
  
<style lang="less">
@import "../style/outOrderInfo.less";

.Already {
    background-color: rgb(1, 165, 1);
    color: white;
    width: 60px;
    height: 20px;
    padding-top: 2px;
    border-radius: 5px;
}

.Nalready {
    background-color: rgb(231, 82, 82);
    color: white;
    width: 60px;
    height: 20px;
    padding-top: 2px;
    border-radius: 5px;
}

.info-data {
    display: flex;
    padding: 0px 10px 10px 10px;
    align-items: center;
    justify-content: center;
}

.bottom-button-x {
    border-radius: 0.5em;
    width: 35%;
}

.list-data {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.list-data-div {
    padding-right: 3px;
    text-align: left;
    font-size: 18px;
}

.list-data-div-a {
    //padding-right: 3px;
    text-align: left;
    font-size: 0.48rem;
    width: 50%;
}

.getreel-input {
    height: 25px;
    width: 4rem;
}

.goods-info-two-f {
    margin-bottom: 10px;
    background-color: #f2f2f2;
    padding-bottom: 20px;
}

.right-Pandian {
    width: 100%;
    margin: 0 15px;
    text-align: left;
    font-size: 0.48rem;
}
</style>